export const et = {
    message1: 'Sõnum 1'
}